import { memo } from 'react';
import { Skeleton } from '@bonanza-social/moonlight';

function PrizeWallInfoPrizesSkeleton() {
  return <Skeleton height={527} />;
}

export default memo(PrizeWallInfoPrizesSkeleton);
